import * as React from "react";
import styled from "../../styled-components";
import { media } from "../../breakpoints";
import { track } from "../../analytics";

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #f2f2f2;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  margin-top: 20px;
  width: 100%;
`;

const Card = styled.div`
  align-items: center;
  border-left: 10px solid ${({ theme }) => theme.colors.blue};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 28px;
  position: relative;

  ${media.PHONE`
    align-items: flex-start;
  padding: 20px 100px 20px 28px;
  `};
`;

const Name = styled.h3`
  color: ${({ theme }) => theme.colors.black};
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;

  ${media.PHONE`
    text-align: left;
  `};
`;

const NumberOfPositions = styled.p`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  text-transform: capitalize;

  ${media.PHONE`
    text-align: left;
  `};
`;

const ExpandButton = styled.button`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid #c9c6c1;
  border-radius: 100%;
  color: #c9c6c1;
  display: flex;
  font-size: 24px;
  height: 56px;
  justify-content: center;
  position: absolute;
  right: 28px;
  width: 56px;

  &:hover {
    cursor: pointer;
  }
`;

const PositionsList = styled.ul`
  border-top: 1px solid #f2f2f2;
  height: auto;
  margin: 0 0 40px;
  padding: 0 28px;
  transition: max-height 0.25s ease, opacity 0.3s ease;
`;

const Position = styled.li`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  transition: margin-top 0.3s ease;

  &:first-child() {
    margin-top: 40px;
  }

  ${media.PHONE`
    align-items: flex-start;
    flex-direction: column;
  `};
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const PositionName = styled.h4`
  color: ${({ theme }) => theme.colors.black};
  font-size: 20px;
  font-weight: 400px;
  line-height: 30px;
`;

const PositionDetails = styled.div`
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;

  ${media.PHONE`
    flex-direction: column;
  `};
`;

const PositionDetail = styled.p`
  margin-right: 28px;
`;

const ViewLink = styled.a`
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: 3px;
  color: ${({ theme }) => theme.colors.blue};
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  transition: background 0.25s ease, color 0.25s ease;
  width: 130px;

  &:hover {
    background: ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.white};
  }

  ${media.PHONE`
  margin-top: 20px;
    width: 100%;
  `};
`;

interface IPosting {
  id: string;
  text: string;
  hostedUrl: string;
  categories: { commitment: string; location: string };
}

interface IDepartmentAccordionProps {
  departmentName: string;
  postings: IPosting[];
}

interface IDepartmentAccordionState {
  isOpen: boolean;
}

export class DepartmentAccordion extends React.Component<
  IDepartmentAccordionProps,
  IDepartmentAccordionState
> {
  public state: IDepartmentAccordionState = {
    isOpen: false
  };

  public render() {
    const { isOpen } = this.state;
    const { postings, departmentName } = this.props;

    const positionsList = postings.map(posting => (
      <Position key={posting.id}>
        <Column>
          <PositionName>{posting.text}</PositionName>
          <PositionDetails>
            <PositionDetail>{posting.categories.location}</PositionDetail>
            <PositionDetail>{departmentName}</PositionDetail>
            <PositionDetail>{posting.categories.commitment}</PositionDetail>
          </PositionDetails>
        </Column>

        <ViewLink
          href={posting.hostedUrl}
          target="_blank"
          onClick={() => this.trackClick(posting.text)}
        >
          View
        </ViewLink>
      </Position>
    ));

    return (
      <Wrapper>
        <Card>
          <Name>{departmentName}</Name>
          <NumberOfPositions>
            {`${postings.length} ${this.pluralize(
              postings.length,
              "position"
            )}`}
          </NumberOfPositions>
          <ExpandButton onClick={() => this.toggle()}>
            {isOpen ? "\u2014" : "+"}
          </ExpandButton>
        </Card>

        {isOpen ? <PositionsList>{positionsList}</PositionsList> : null}
      </Wrapper>
    );
  }

  private pluralize(quantity: number, text: string) {
    if (quantity > 1) {
      return `${text}s`;
    }

    return text;
  }

  private toggle() {
    track(
      `${this.state.isOpen ? "Collapsed" : "Expanded"} ${
        this.props.departmentName
      }`
    );

    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  private trackClick(position: string) {
    track(`Viewed ${position}`);
  }
}



// WEBPACK FOOTER //
// ./src/pages/Careers/DepartmentAccordion.tsx